<template>
    <el-dialog 
      :visible="dialogVisible" 
      :append-to-body="true" 
      v-loading="loading" 
      title="" 
      @close="cancel">

      <component 
      :is="handleType" 
      :billData="billData"
      ref="form">
      </component>

      <div :class="$style['button-div']">
          <el-button type="primary" @click="submit">确认</el-button>
          <el-button type="primary" plain @click="cancel">取消</el-button>
      </div>
    </el-dialog>
</template>
<script>
import YAN_QI_JIAO_FU from './YAN_QI_JIAO_FU.vue'
import BILL_HANDLE from './BILL_HANDLE.vue'
import BILL_DELIVERY from './BILL_DELIVERY.vue'
import {nextTrust} from '../status'

export default {
  name: 'delay-dialog',
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    handleType: {
      type: String,
      required: true
    },
    billData: {
      type: Object,
      default: ()=>{}
    },
  },
  components:{
    YAN_QI_JIAO_FU,
    BILL_HANDLE,
    BILL_DELIVERY
  },
  data () {
    return {
      loading:false
    }
  },
  watch: {
   
  },
  methods: {
    submit(){
      this.$refs.form.formValidata().then((form)=>{
        console.log('-succ',form)
        this.loading = true
        this.submitForm(form)
      })
    },
    delay(form){
      let data = {
        ids:[this.billData.id],
        ...form
      }
      this.$store.dispatch('handleDelay', data).then(res => {
        this.$message.success('操作成功')
        this.$emit('reload')
        this.cancel()
      }).catch(err => {
        this.$message.warning(err || '操作失败')
      }).finally(()=>{
        this.loading = false
      })
    },
    handle(form){
      console.log('====form',JSON.stringify(form))
      let data = {
        billId: this.billData.id,
        action: 'BILL_DELIVER',
        billStatusDetail:{
          action: 'BILL_DELIVER',
          billStatusResult:'BILL_HANDLE',
          ...form,
          expressIds:form.expressIds?.map(e=>e.value)
        }
      }
      nextTrust.call(this,data).then(response => {
        this.$message.success('操作成功')
        this.$emit('reload')
        this.cancel()
      }).catch(err => {
        this.$message.error(err.message || err)
      }).finally(()=>{
        this.loading = false
      })
    },
    over(form){
     let data = {
        billId: this.billData.id,
        action: 'BILL_DELIVER',
        billStatusDetail:{
          action: 'BILL_DELIVER',
          billStatusResult:'BILL_DELIVERY',
          comment:form.comment,
          expressIds:[form.expressId],
          attachmentFileInformationList:form.attachments?.map(item=>{
            return{
              type:'BILL_PDF_REPORT',
              name: item.name,
              ossUrl: item.response
            }
          })
        }
      }
      nextTrust.call(this,data).then(response => {
        this.$message.success('操作成功')
        this.$emit('reload')
        this.cancel()
      }).catch(err => {
        this.$message.error(err.message || err)
      }).finally(()=>{
        this.loading = false
      })
    },
    submitForm(form){
      switch (this.handleType) {
        case 'YAN_QI_JIAO_FU':
          this.delay(form)
          break
        case 'BILL_HANDLE':
          this.handle(form)
          break
        case 'BILL_DELIVERY':
          this.over(form)
          break
      }
    },
    cancel () {
      this.$emit('close')
    },
    
  }
}
</script>
<style module lang="less">
  .button-div{
  margin-top: 40px;
  }
</style>
